import '../data/blog-styles.css';

const html = `
<div class="blog-content">
  <!-- 1. BlogPosting Schema -->
  <script type="application/ld+json">
  {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": "https://mon-depannage-informatique.fr/blog/crochet-macbook-5-raccourcis-indispensables-2025"
    },
    "headline": "Crochet macbook : 5 Raccourcis Indispensables en 2025",
    "description": "Découvrez comment faire un crochet sur macbook avec 5 raccourcis clavier essentiels. Guide expert AZERTY/QWERTY, alternatives et astuces pour Mac.",
    "image": {
      "@type": "ImageObject",
      "url": "https://mon-depannage-informatique.fr/imagesposts/blog40/crochet-macbook-image-1.webp",
      "width": 800,
      "height": 450
    },
    "author": {
      "@type": "Person",
      "name": "Thomas"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Mon Dépannage Informatique",
      "url": "https://mon-depannage-informatique.fr",
      "logo": {
        "@type": "ImageObject",
        "url": "https://mon-depannage-informatique.fr/static/media/mon-depannage-informatique-logo.webp"
      }
    },
    "datePublished": "2025-11-28T10:00:00+01:00",
    "dateModified": "2025-11-28T10:00:00+01:00",
    "inLanguage": "fr-FR"
  }
  </script>

  <!-- 2. FAQPage Schema -->
  <script type="application/ld+json">
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "Quelle est la différence entre crochet et accolade sur Mac ?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Visuellement, le crochet est droit [ ] alors que l'accolade est courbe avec une pointe { }. Techniquement, le raccourci est très proche : pour les accolades, il faut utiliser la même combinaison (Option + 5) mais SANS la touche Maj sur les anciens systèmes, ou Option + ( sur les nouveaux. En programmation, les crochets définissent des listes, les accolades des blocs de code ou des objets."
        }
      },
      {
        "@type": "Question",
        "name": "Pourquoi mon raccourci crochet ne fonctionne pas sur Word ?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Il arrive que Microsoft Word possède ses propres raccourcis qui entrent en conflit avec ceux du système. Vérifiez dans les préférences de Word, rubrique Correction automatique ou Raccourcis clavier, si la combinaison Option+Maj+5 n'est pas assignée à une autre fonction. Parfois, c'est aussi simplement la police d'écriture sélectionnée qui n'affiche pas correctement ce caractère."
        }
      },
      {
        "@type": "Question",
        "name": "Comment faire un crochet sur un MacBook Air M1/M2 ?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Rassurez-vous, le changement de processeur vers les puces Apple Silicon (M1, M2, M3) n'a absolument rien changé à la disposition du clavier. La méthode reste strictement identique : Option + Maj + 5. Apple conserve une cohérence totale sur ses périphériques d'entrée depuis des années."
        }
      },
      {
        "@type": "Question",
        "name": "Peut-on créer un raccourci personnalisé pour les crochets ?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Oui, et c'est très pratique ! Allez dans Réglages Système > Clavier > Remplacement de texte. Cliquez sur le + et ajoutez une règle. Par exemple, choisissez de remplacer crr par [. Dès que vous taperez crr suivi d'espace, le Mac insérera le crochet automatiquement."
        }
      },
      {
        "@type": "Question",
        "name": "Où se trouvent les crochets sur un clavier Mac suisse ?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Nos amis suisses ont un clavier QWERTZ spécifique. Chez eux, c'est bien plus simple que sur le clavier français : pas besoin de la touche Majuscule ! Le crochet ouvrant se fait avec Option + 5 et le fermant avec Option + 6. C'est une différence subtile mais cruciale si vous traversez la frontière."
        }
      }
    ]
  }
  </script>

  <!-- 3. BreadcrumbList Schema -->
  <script type="application/ld+json">
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Accueil",
        "item": "https://mon-depannage-informatique.fr"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Blog",
        "item": "https://mon-depannage-informatique.fr/blog"
      },
      {
        "@type": "ListItem",
        "position": 3,
        "name": "Crochet macbook : 5 Raccourcis Indispensables en 2025",
        "item": "https://mon-depannage-informatique.fr/blog/crochet-macbook-5-raccourcis-indispensables-2025"
      }
    ]
  }
  </script>

  <div>

<h1>Crochet macbook : 5 Raccourcis Indispensables en 2025</h1>

<!-- 2. INTRODUCTION / RÉSUMÉ RAPIDE -->
<p>🧙‍♂️ <strong>Pas le temps de lire ? Ce qu'il faut savoir absolument :</strong>
<br>📌 <strong>La combinaison gagnante (AZERTY) :</strong> Maintenez <strong>Option (Alt)</strong> + <strong>Maj (Shift)</strong> + <strong>5</strong> pour ouvrir, et la touche <strong>°</strong> pour fermer.
<br>📌 <strong>Le piège à éviter :</strong> Ne confondez pas les touches Cmd (pomme) et Option (Alt), c'est l'erreur la plus fréquente.
<br>📌 <strong>L'alternative de secours :</strong> Le "Visualiseur de clavier" accessible via la barre des menus pour cliquer virtuellement sur les touches.
<br>📌 <strong>L'astuce clavier PC :</strong> Sur un clavier Windows branché au Mac, la touche "Alt Gr" est souvent remplacée par "Alt" simple.
<br>📌 <strong>Le gain de productivité :</strong> Configurez un remplacement de texte automatique si la gymnastique des doigts vous fatigue.
</p>

<!-- 3. SOMMAIRE -->
<h2>Sommaire</h2>
<ol>
    <li><a href="#section-1">La méthode standard : Le raccourci clavier crochet macbook indispensable</a></li>
    <li><a href="#section-2">Adapter la saisie selon votre configuration (AZERTY vs QWERTY)</a></li>
    <li><a href="#section-3">3 Alternatives efficaces quand le raccourci échoue</a></li>
    <li><a href="#section-4">Cas particulier : Faire des crochets avec un clavier PC sur Mac</a></li>
    <li><a href="#section-5">Usages avancés et mémorisation : Devenez un expert du clavier Apple</a></li>
</ol>

<!-- 4. CORPS DE L'ARTICLE -->

<!-- Section 1 -->
<h2 id="section-1">La méthode standard : Le raccourci clavier crochet macbook indispensable</h2>
<p>On s'est tous retrouvés, au moins une fois lors de nos débuts sur macOS, à fixer le clavier en cherchant désespérément ces fameux crochets. Contrairement aux PC Windows où ils sont souvent gravés sur la touche, Apple privilégie l'esthétisme et cache ces caractères. La solution réside dans une combinaison de touches spécifique, une "gymnastique" que vous allez vite mémoriser.</p>

<h3 id="sous-section-1-1">Identifier les touches modificatrices (Option et Maj)</h3>
<p>Pour réussir cette manipulation, il faut d'abord localiser vos outils. Sur tous les MacBook (Air, Pro) et claviers Magic Keyboard, la touche clé est <strong>Option</strong> (parfois marquée <strong>Alt</strong> ⌥). Elle se situe généralement entre la touche Contrôle (Ctrl) et la touche Commande (Cmd). Ensuite, repérez la touche <strong>Majuscule</strong> (Shift ⇧), située juste au-dessus de la touche Ctrl ou au-dessus des flèches directionnelles.</p>

<h3 id="sous-section-1-2">La combinaison exacte pour les crochets ouvrants et fermants</h3>
<p>Une fois vos doigts positionnés, voici la procédure exacte pour un clavier français standard (AZERTY). En effet, le crochet est considéré par le système comme une "parenthèse de niveau supérieur".</p>

<ul>
    <li><strong>Pour le crochet ouvrant [</strong> : Maintenez <strong>Option</strong> + <strong>Maj</strong> avec votre main gauche, puis appuyez sur la touche <strong>5</strong> (celle qui contient la parenthèse ouvrante) avec l'autre main.</li>
    <li><strong>Pour le crochet fermant ]</strong> : Maintenez toujours <strong>Option</strong> + <strong>Maj</strong>, mais appuyez cette fois sur la touche <strong>°</strong> (celle qui contient la parenthèse fermante, juste à droite du zéro).</li>
    <li><strong>Conseil ergonomique</strong> : Pour gagner en fluidité, je vous conseille d'utiliser le pouce gauche pour Option et l'auriculaire gauche pour Maj. Cela libère totalement votre main droite pour aller chercher le 5 ou le °.</li>
</ul>

<!-- IMAGE 1 - OBLIGATOIRE -->
<img src="/imagesposts/blog40/crochet-macbook-image-1.webp" alt="Position des doigts sur clavier Apple pour faire un crochet macbook raccourci" title="Raccourci clavier crochet Mac" loading="lazy" width="800" height="450">

<!-- Section 2 -->
<h2 id="section-2">Adapter la saisie selon votre configuration (AZERTY vs QWERTY)</h2>
<p>Si vous voyagez ou si vous utilisez du matériel importé, la logique change radicalement. En tant que consultant technique, je vois souvent des utilisateurs frustrés car ils appliquent la méthode française sur un clavier américain ou suisse. L'architecture du clavier (le layout) dicte la règle.</p>

<h3 id="sous-section-2-1">Spécificités du clavier français AZERTY Apple</h3>
<p>Le clavier AZERTY Apple est particulier car la rangée numérique nécessite déjà la touche Maj pour obtenir les chiffres. C'est pourquoi l'ajout de la touche Option est nécessaire pour atteindre la "troisième couche" de caractères. C'est une spécificité qui rend la saisie de code parfois plus laborieuse que sur les modèles anglo-saxons.</p>

<h3 id="sous-section-2-2">Gérer les claviers QWERTY (US et International)</h3>
<p>Si vous codez, vous avez peut-être opté pour un clavier QWERTY US. Ici, c'est le bonheur : les crochets ont leurs propres touches dédiées, situées généralement à droite de la touche "P". Aucune combinaison complexe n'est requise, une simple pression suffit. C'est un gain de temps considérable pour les développeurs.</p>

<!-- TABLEAU 1 - OBLIGATOIRE : 3 colonnes + 3 lignes -->
<h3 id="tableau-1">Comparatif des raccourcis crochets selon la langue du clavier</h3>
<table>
    <thead>
        <tr>
            <th>Type de Clavier</th>
            <th>Raccourci Crochet Ouvrant [</th>
            <th>Raccourci Crochet Fermant ]</th>
        </tr>
    </thead>
    <tbody>
        <tr>
            <td><strong>AZERTY (France)</strong></td>
            <td>Option + Maj + 5</td>
            <td>Option + Maj + ° (touche du degré)</td>
        </tr>
        <tr>
            <td><strong>QWERTY (US)</strong></td>
            <td>Touche directe [ (droite du P)</td>
            <td>Touche directe ] (droite du [)</td>
        </tr>
        <tr>
            <td><strong>QWERTZ (Suisse)</strong></td>
            <td>Option + 5 (sans Maj)</td>
            <td>Option + 6 (sans Maj)</td>
        </tr>
    </tbody>
</table>

<!-- Section 3 -->
<h2 id="section-3">3 Alternatives efficaces quand le raccourci échoue</h2>
<p>Il arrive que le clavier physique fasse des siennes, qu'une touche soit bloquée ou que vous ne parveniez tout simplement pas à effectuer la combinaison. Pas de panique, macOS offre des solutions logicielles très puissantes pour contourner le matériel.</p>

<h3 id="sous-section-3-1">Utiliser le visualiseur de caractères (Emoji & Symboles)</h3>
<p>C'est l'outil méconnu que je recommande toujours d'activer. Allez dans les <em>Réglages Système</em> > <em>Clavier</em>, et assurez-vous que la méthode de saisie est visible dans la barre des menus. En cliquant sur l'icône "A" ou "FR" en haut à droite de votre écran, vous pouvez choisir "Afficher le visualiseur de clavier". Une version virtuelle de votre clavier apparaît à l'écran : cliquez sur les touches avec votre souris pour insérer les crochets.</p>

<h3 id="sous-section-3-2">La technique du "Rechercher-Remplacer" ou Copier-Coller</h3>
<p>Dans l'urgence absolue, Google est votre ami. Tapez "crochet ouvrant" dans la barre de recherche, copiez le symbole qui apparaît, et collez-le dans votre document. Pour aller plus loin, vous pouvez utiliser la fonction native de remplacement de texte de macOS (Réglages > Clavier > Remplacement de texte). Par exemple, configurez le système pour qu'il remplace automatiquement "(((" par "[". C'est une astuce que j'utilise personnellement pour gagner du temps.</p>

<!-- TABLEAU 2 - OBLIGATOIRE : 3 colonnes + 3 lignes -->
<h3 id="tableau-2">Efficacité des méthodes alternatives sur macOS</h3>
<table>
    <thead>
        <tr>
            <th>Méthode Alternative</th>
            <th>Vitesse d'exécution</th>
            <th>Contexte idéal</th>
        </tr>
    </thead>
    <tbody>
        <tr>
            <td><strong>Visualiseur de clavier</strong></td>
            <td>Lente (nécessite la souris)</td>
            <td>Panne physique d'une touche ou apprentissage</td>
        </tr>
        <tr>
            <td><strong>Copier-Coller Web</strong></td>
            <td>Très lente</td>
            <td>Dépannage unique sur un ordinateur tiers</td>
        </tr>
        <tr>
            <td><strong>Substitution textuelle</strong></td>
            <td>Ultra-rapide (automatique)</td>
            <td>Rédaction intensive si le raccourci est pénible</td>
        </tr>
    </tbody>
</table>

<!-- Section 4 -->
<h2 id="section-4">Cas particulier : Faire des crochets avec un clavier PC sur Mac</h2>
<p>Vous avez branché un clavier USB ou Bluetooth conçu pour Windows sur votre Mac ? C'est une situation classique en entreprise qui crée beaucoup de confusion, car les sérigraphies sur les touches ne correspondent plus à la réalité logicielle de macOS.</p>

<h3 id="sous-section-4-1">Comprendre l'inversion des touches Windows/Command</h3>
<p>Sur un clavier PC, la touche <strong>Windows</strong> joue le rôle de la touche <strong>Command</strong> (Cmd), et la touche <strong>Alt</strong> reste <strong>Option</strong>. Le problème, c'est que leurs positions physiques sont inversées par rapport à un clavier Apple officiel. Ainsi, pour faire un crochet, vous devrez utiliser la touche Alt (située à gauche de la barre espace) combinée à Maj et à la touche parenthèse. Attention, la touche <strong>Alt Gr</strong> (à droite) ne fonctionne pas toujours comme prévu sur macOS par défaut.</p>

<h3 id="sous-section-4-2">Configuration recommandée pour les claviers tiers</h3>
<p>Pour retrouver vos repères, je vous suggère fortement de remapper les touches. Rendez-vous dans <em>Réglages Système</em> > <em>Clavier</em> > <em>Raccourcis clavier</em> > <em>Touches de modification</em>. Ici, vous pouvez dire au Mac de traiter la touche "Control" physique comme une touche "Option", par exemple.</p>

<ul>
    <li><strong>Outil natif</strong> : Les "Touches de modification" dans les réglages système suffisent pour inverser Cmd et Alt.</li>
    <li><strong>Logiciel tiers</strong> : Pour les utilisateurs avancés, l'application gratuite <em>Karabiner-Elements</em> permet de reprogrammer chaque touche individuellement.</li>
    <li><strong>Astuce physique</strong> : Si vous utilisez ce clavier en permanence, collez de petites gommettes sur les touches pour masquer les symboles Windows erronés.</li>
</ul>

<!-- Section 5 -->
<h2 id="section-5">Usages avancés et mémorisation : Devenez un expert du clavier Apple</h2>
<p>Maîtriser ces raccourcis n'est pas qu'une question de confort, c'est une nécessité professionnelle. Dans certains métiers, la recherche des caractères spéciaux peut représenter une perte de productivité cumulée importante sur une année.</p>

<h3 id="sous-section-5-1">Pourquoi les crochets sont vitaux en développement (Python, JS)</h3>
<p>Si vous débutez en programmation, sachez que le crochet est omniprésent. En Python, JavaScript ou Swift, ils servent à définir des listes (arrays) et des tableaux. Imaginez devoir chercher la combinaison à chaque déclaration de variable ! C'est pourquoi la plupart des développeurs finissent par adopter le clavier QWERTY US ou par connaître le raccourci AZERTY par mémoire musculaire pure.</p>

<!-- IMAGE 2 - OBLIGATOIRE -->
<img src="/imagesposts/blog40/crochet-macbook-image-2.webp" alt="Utilisation des crochets macbook dans un code python sur écran" title="Crochets en programmation sur Mac" loading="lazy" width="800" height="450">

<h3 id="sous-section-5-2">Mémotechnique simple pour ne plus jamais oublier</h3>
<p>Pour ne plus jamais hésiter, retenez cette logique simple : sur Mac, la touche <strong>Option</strong> sert à obtenir des variantes d'un caractère.
<br>La parenthèse <strong>(</strong> est le caractère de base.
<br>Le crochet <strong>[</strong> est une "parenthèse carrée".
<br>Donc : Raccourci Parenthèse + Touche Option = Crochet.
<br>C'est aussi simple que cela : vous ajoutez une "option" à votre parenthèse classique.</p>

<!-- 5. MINI FAQ - OBLIGATOIRE -->
<h2>🧠 Mini FAQ pour les pressés (ou les flemmards, on t'voit 👀)</h2>

<h3>Quelle est la différence entre crochet et accolade sur Mac ?</h3>
<p>Visuellement, le crochet est droit <strong>[ ]</strong> alors que l'accolade est courbe avec une pointe <strong>{ }</strong>. Techniquement, le raccourci est très proche : pour les accolades, il faut utiliser la même combinaison (Option + 5) mais SANS la touche Maj sur les anciens systèmes, ou Option + ( sur les nouveaux. En programmation, les crochets définissent des listes, les accolades des blocs de code ou des objets.</p>

<h3>Pourquoi mon raccourci crochet ne fonctionne pas sur Word ?</h3>
<p>Il arrive que Microsoft Word possède ses propres raccourcis qui entrent en conflit avec ceux du système. Vérifiez dans les préférences de Word, rubrique "Correction automatique" ou "Raccourcis clavier", si la combinaison Option+Maj+5 n'est pas assignée à une autre fonction. Parfois, c'est aussi simplement la police d'écriture sélectionnée qui n'affiche pas correctement ce caractère.</p>

<h3>Comment faire un crochet sur un MacBook Air M1/M2 ?</h3>
<p>Rassurez-vous, le changement de processeur vers les puces Apple Silicon (M1, M2, M3) n'a absolument rien changé à la disposition du clavier. La méthode reste strictement identique : Option + Maj + 5. Apple conserve une cohérence totale sur ses périphériques d'entrée depuis des années.</p>

<h3>Peut-on créer un raccourci personnalisé pour les crochets ?</h3>
<p>Oui, et c'est très pratique ! Allez dans <em>Réglages Système</em> > <em>Clavier</em> > <em>Remplacement de texte</em>. Cliquez sur le "+" et ajoutez une règle. Par exemple, choisissez de remplacer "crr" par "[". Dès que vous taperez "crr" suivi d'espace, le Mac insérera le crochet automatiquement.</p>

<h3>Où se trouvent les crochets sur un clavier Mac suisse ?</h3>
<p>Nos amis suisses ont un clavier QWERTZ spécifique. Chez eux, c'est bien plus simple que sur le clavier français : pas besoin de la touche Majuscule ! Le crochet ouvrant se fait avec <strong>Option + 5</strong> et le fermant avec <strong>Option + 6</strong>. C'est une différence subtile mais cruciale si vous traversez la frontière.</p>

  </div>
</div>
`;

export const blogMeta = {
  id: "crochet-macbook-5-raccourcis-indispensables-2025",
  slug: "crochet-macbook-5-raccourcis-indispensables-2025",
  title: "Crochet macbook : 5 Raccourcis Indispensables en 2025",
  description: "Découvrez comment faire un crochet sur macbook avec 5 raccourcis clavier essentiels. Guide expert AZERTY/QWERTY, alternatives et astuces pour Mac.",
  date: "28 Novembre 2025",
  category: "Tutoriels",
  image: "/imagesposts/blog40/crochet-macbook-image-1.webp",
  author: "Thomas",
  publishedAt: "28 novembre 2025, 10 h 00",
  readingTime: "9 minutes de lecture",
  url: "/blog/crochet-macbook-5-raccourcis-indispensables-2025",
  html
};
